import React, { useState } from "react";
import { CircleCheck, Clock, CircleAlert, Newspaper, ShieldCheck, CircleCheck as CheckCircle2, Loader as Loader2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
interface SubmissionconfirmationProps {
  onSubmit?: () => Promise<void> | void;
  isSubmitting?: boolean;
}
export default function Submissionconfirmation({
  onSubmit,
  isSubmitting = false
}: SubmissionconfirmationProps) {
  const [agreements, setAgreements] = useState({
    accurate: false,
    contactable: false,
    verified: false,
    plagiarism: false,
    mediaUsage: false,
    privacy: false
  });
  const validationStates = {
    gpsActive: true,
    hasCoordinates: true,
    isLandscapePhoto: true,
    titleLengthOk: true,
    contentLengthOk: true,
    categorySelected: true,
    senderDataComplete: true
  };
  const allAgreed = Object.values(agreements).every(Boolean);
  const canSubmit = allAgreed && validationStates.gpsActive && validationStates.hasCoordinates && validationStates.isLandscapePhoto && validationStates.titleLengthOk && validationStates.contentLengthOk && validationStates.categorySelected && validationStates.senderDataComplete;
  const handleCheckboxChange = (key: keyof typeof agreements) => {
    setAgreements(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  const agreementItems = [{
    id: "accurate",
    label: "Informasi yang saya kirim benar dan akurat"
  }, {
    id: "contactable",
    label: "Bersedia dihubungi oleh redaksi ABADI.NEWS"
  }, {
    id: "verified",
    label: "Memahami berita akan diverifikasi sebelum dipublikasikan"
  }, {
    id: "plagiarism",
    label: "Berita, foto, video dan dokumen yang saya kirim bukan hasil plagiarisme atau mengambil karya pihak lain tanpa izin."
  }, {
    id: "mediaUsage",
    label: "Saya memberikan izin kepada ABADI.NEWS untuk menggunakan foto, video dan dokumen yang saya kirimkan untuk kebutuhan publikasi berita."
  }, {
    id: "privacy",
    label: "Menyetujui Kebijakan Privasi dan Syarat & Ketentuan"
  }];
  return <section data-section-id="263487" id="submissionconfirmation" className="w-full py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="mb-12 text-center animate-in fade-in slide-in-from-bottom-4 duration-700">
          <div className="inline-flex items-center justify-center p-2 mb-4 rounded-lg bg-primary/10 text-primary">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl font-default text-foreground mb-4">
            Konfirmasi Akhir
          </h2>
          <p className="max-w-[700px] mx-auto text-muted-foreground md:text-lg font-default leading-relaxed">
            Tinjau kembali draf Anda. Pastikan semua informasi telah sesuai dengan standar jurnalistik ABADI.NEWS sebelum dikirim ke meja redaksi.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          
          <div className="lg:col-span-5 space-y-6 animate-in fade-in slide-in-from-left-4 duration-700 delay-100">
            <div className="bg-card rounded-lg shadow-sm border border-border p-6">
              <h3 className="text-sm font-bold uppercase tracking-widest text-muted-foreground mb-4">Status Pengiriman</h3>
              <div className="flex items-center gap-4 p-4 bg-muted/50 rounded-lg border border-border/50">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary text-white shadow-md">
                  <Clock className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-muted-foreground uppercase">Kondisi Saat Ini</p>
                  <p className="text-xl font-bold text-foreground">Draf Siap Kirim</p>
                </div>
              </div>
              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-2 text-sm text-emerald-600 font-medium">
                  <CheckCircle2 className="h-4 w-4" />
                  <span>Validasi konten berhasil</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-emerald-600 font-medium">
                  <CheckCircle2 className="h-4 w-4" />
                  <span>Metadata lokasi terlampir</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-emerald-600 font-medium">
                  <CheckCircle2 className="h-4 w-4" />
                  <span>Media pendukung sesuai standar</span>
                </div>
              </div>
            </div>

            <div className="p-6 bg-secondary rounded-lg text-secondary-foreground">
              <h4 className="font-bold mb-2">Catatan Redaksi:</h4>
              <p className="text-sm opacity-80 leading-relaxed">
                Setiap berita yang masuk akan melalui proses kurasi ketat. Pastikan Anda mencantumkan sumber yang jelas jika mengutip pernyataan pihak lain.
              </p>
            </div>
          </div>

          
          <div className="lg:col-span-7 space-y-6 animate-in fade-in slide-in-from-right-4 duration-700 delay-200">
            <div className="bg-card rounded-lg shadow-md border border-border p-6 md:p-8">
              <div className="flex items-center gap-2 mb-6">
                <div className="h-1 w-8 bg-primary rounded-lg"></div>
                <h3 className="text-lg font-bold font-default uppercase tracking-tight">Persetujuan & Konfirmasi</h3>
              </div>
              
              <div className="space-y-4 mb-8">
                {agreementItems.map((item, i) => <div key={item.id} data-index={i} className={`flex items-start space-x-4 p-4 rounded-lg border transition-all duration-300 ${agreements[item.id as keyof typeof agreements] ? "bg-primary/5 border-primary/30 shadow-sm" : "bg-background border-border hover:border-primary/20"}`}>
                    <div className="flex items-center h-6">
                      <input id={item.id} type="checkbox" checked={agreements[item.id as keyof typeof agreements]} onChange={() => handleCheckboxChange(item.id as keyof typeof agreements)} className="h-5 w-5 rounded border-input cursor-pointer accent-primary transition-transform active:scale-90" />
                    </div>
                    <label htmlFor={item.id} className="text-base font-medium leading-tight cursor-pointer select-none text-foreground/90">
                      {item.label}
                    </label>
                  </div>)}
              </div>

              <div className="space-y-4">
                <Button disabled={!canSubmit || isSubmitting} onClick={() => onSubmit?.()} className={`w-full h-14 text-lg font-bold rounded-lg transition-all duration-500 shadow-md flex items-center justify-center gap-3 ${canSubmit && !isSubmitting ? "bg-primary hover:bg-primary/90 text-white cursor-pointer hover:scale-[1.01] active:scale-[0.98]" : "bg-muted text-muted-foreground cursor-not-allowed opacity-70"}`}>
                  {isSubmitting ? <>
                      <Loader2 className="h-5 w-5 animate-spin" />
                      Mengirim...
                    </> : <>
                      <Newspaper className="h-5 w-5" />
                      Kirim ke Redaksi Sekarang
                    </>}
                </Button>

                {!allAgreed && <div className="flex items-center justify-center gap-2 text-sm text-destructive font-semibold animate-pulse">
                    <CircleAlert className="h-4 w-4" />
                    <span>Harap lengkapi semua persetujuan di atas</span>
                  </div>}

                <p className="text-center text-xs text-muted-foreground px-4">
                  Dengan menekan tombol kirim, Anda menyatakan tunduk pada <Link to="/CyberMediaGuidePage" className="text-primary font-semibold hover:underline">Pedoman Media Siber</Link> dan <Link to="/PrivacyPolicyPage" className="text-primary font-semibold hover:underline">Kebijakan Privasi</Link> ABADI.NEWS.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}